import { transformCurrencyAmountDto } from './currency-amount';
import { transformVasGalleryOrderItemDto } from './vas-gallery-order';
export const transformVasGalleryPricingDto = dto => ({
  durationDays: dto.duration_days,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  items: dto.items.map(transformVasGalleryOrderItemDto)
});